import { API } from 'aws-amplify';

// Sanity blog document writes go through the admin backend so the Sanity write
// token stays server side. Reads still use the public read-only client in
// src/sanity/client.ts.
const mutate = async (
	accountId: number,
	body: { action: 'create' | 'patch' | 'delete'; id?: string; doc?: any }
) => {
	return API.post('api', `/${accountId}/blog-post`, { body });
};

export const createPost = async (accountId: number, doc: any) => {
	return mutate(accountId, { action: 'create', doc });
};

export const patchPost = async (accountId: number, id: string, doc: any) => {
	return mutate(accountId, { action: 'patch', id, doc });
};

export const deletePost = async (accountId: number, id: string) => {
	return mutate(accountId, { action: 'delete', id });
};
